import { useState } from 'react';

import SurveyAnswer from '../../../../shared/models/survey/SurveyAnswer';
import SurveyChoiceOption from '../../../../shared/models/survey/SurveyChoiceOption';
import { SurveyMultipleChoiceQuestionType } from '../SurveyQuestionTypes';

type PropType = SurveyMultipleChoiceQuestionType & {
  id: string;
  onAnswerSelect: (answer: SurveyAnswer) => void;
  options: SurveyChoiceOption[];
  bem: (element: string | null, modifier?: string | null, condition?: boolean) => string;
  previousAnswer: string[];
};

const SurveyRadioQuestion = ({ bem, id, options, onAnswerSelect, previousAnswer }: PropType) => {
  const [selectedAnswers, setSelectedAnswers] = useState<string[]>(previousAnswer || []);
  const handleOnChange = (optionId: string) => {
    const index = selectedAnswers.indexOf(optionId);
    let answers: string[] = [];
    if (index !== -1) {
      answers = [];
    } else {
      answers = [optionId];
    }

    setSelectedAnswers(answers);
    onAnswerSelect({
      value: answers,
      questionId: id,
    });
  };

  return (
    <div className={bem('radio')}>
      {options.map(({ description, id: optionId }) => (
        <div
          key={`${id}_${optionId}`}
          className={bem('radio-option')}
        >
          <input
            type="radio"
            name={id}
            id={optionId}
            value={optionId}
            checked={selectedAnswers.includes(optionId)}
            onChange={() => handleOnChange(optionId)}
            className={bem('radio-option')}
          />
          <label
            htmlFor={optionId}
            key={optionId}
          >
            {description}
          </label>
        </div>
      ))}
    </div>
  );
};

export default SurveyRadioQuestion;
